<script lang="ts" module>
  import { getContext, setContext, type Snippet } from 'svelte';
  import { Dims } from './dimensions.svelte';

  const dimsKey = Symbol('dimensions');
  export const getDimensions = () => getContext<Dims>(dimsKey);
</script>

<script lang="ts">
  type Props = {
    width?: number;
    height?: number;
    dims?: Dims;
    children: Snippet;
  };
  const props: Props = $props();
  setContext(
    dimsKey,
    props.dims ?? {
      board: {
        width: props.width,
        height: props.height,
      },
      aspect: props.width! / props.height!,
    },
  );
</script>

{@render props.children()}
